/**
 * Notice management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class NoticeManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async countNotices(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/system/notice/count', { params });
  }

  async listNotices(page = 1, size = 20, params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/system/notice', {
      params: { page, size, ...params },
    });
  }

  async recordRead(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/system/notice/recordRead', { data });
  }

  async countUnreadNotices(): Promise<Record<string, any>> {
    return this.session.get('/api/system/notice/count', {
      params: { readFlag: false, status: 0 },
    });
  }

  async countUnreadBoards(): Promise<Record<string, any>> {
    return this.session.get('/api/system/notice/count', {
      params: { readFlag: false, type: 2, status: 0 },
    });
  }

  async createNotice(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/system/notice/create', { data });
  }

  async updateNotice(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/system/notice/update', { data });
  }

  async deleteNotices(ids: Array<string | number>): Promise<Record<string, any>> {
    return this.session.post('/api/system/notice/delete', { data: ids });
  }
}
